<template>
  <div id="app">
    <section id="contentCnt">
      <router-view v-on:live="live = true"/>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss">
body{
  margin: 0;
  padding: 0;
  // font-family: 'Rubik', sans-serif;
  // font-family: 'AktivGroteskVF_Trial_WghtWdthItal', sans-serif;
  // font-family: 'Manrope', sans-serif;
  font-family: "Helvetica Neue", Helvetica, Arial, "Lucida Grande", "Inter", sans-serif;
  font-weight: 400;
  color: #444;
  line-height: 1.3;
  background-color: #fff;
  &.hideFooter{
    footer{ display: none; }
  }
  &.no-scroll{
    overflow: hidden;
  }
  input, textarea, select{
    // font-family: 'Rubik', sans-serif;
    // font-family: 'AktivGroteskVF_Trial_WghtWdthItal', sans-serif;
    // font-family: 'Manrope', sans-serif;
    font-family: "Helvetica Neue", Helvetica, Arial, "Lucida Grande", "Inter", sans-serif;
    font-weight: 300;
  }
  b{
    font-weight: 500;
  }
}
#contentCnt{
  min-height: calc(100vh - 100px);
  @media (max-width: 760px) {
    min-height: calc(100vh - 54px);
  }
}
.loadingLanguage{
  height: 100vh;
  background-image: url(assets/loading.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
}
a{ text-decoration: none; color: #115457; }
a:hover{ color: #369d66; }
button, .btn{
  border-radius: 3px;
  padding: 10px 20px;
  background-color: #115457;
  color: #fff;
  border: none;
  font-size: 18px;
  cursor: pointer;
  transition: all .3s ease;
  // font-family: 'Inter', sans-serif;
  font-weight: 500;
  @media (max-width: 1460px) {
    font-size: 16px;
    padding: 8px 16px;
  }
  &:hover{
    color: #fff;
    background-color: #369d66;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
  }
  &.secondary{
    color: rgba(0, 0, 0, .7);
    background-color: #fff;
    border: #ccc 1px solid;
  }
  &.btnLoading{
    transition: none;
    background-color: #ccc;
    background-image: url(assets/loading.svg);
    background-position: center;
    background-size: 24px auto;
    background-repeat: no-repeat;
    span{
      visibility: hidden;
    }
  }
}
.cnt{
  max-width: 1400px;
  margin: 0 auto;
  @media (max-width: 1480px) {
    max-width: 1200px;
  }
  @media (max-width: 1280px) {
    max-width: none;
    margin: 0 20px;
  }
  @media (max-width: 960px) {
    margin: 0 16px;
  }
}

.paginationCnt{
  display: flex;
  justify-content: right;
  @media (max-width: 680px) {
    justify-content: center;
  }
  .pItem{
    width: 46px; height: 40px;
    border: #444 1px solid;
    border-radius: 3px;
    font-size: 15px;
    text-align: center;
    box-sizing: border-box;
    margin-left: 5px;
    padding-top: 9px;
    transition: all .3s ease;
    cursor: pointer;
    @media (max-width: 680px) {
      width: 40px;
      font-size: 14px;
      padding-top: 10px;
      margin: 0 3px;
    }
    &.pn{
      padding-top: 7px;
    }
    &.more{
      border-color: transparent !important;
      color: #999 !important;
      letter-spacing: 2px;
      cursor: default;
    }
    &.active{
      cursor: default;
    }
    &.active,
    &:hover{
      border-color: #80f4b3;
      color: #80f4b3;
    }
  }
}

.viewMoreCnt{
  text-align: center;
  .viewMore{
    color: #80f4b3;
    border: #80f4b3 1px solid;
    padding: 10px 24px;
    border-radius: 50px;
    position: relative;
    display: inline-block;
    padding-right: 50px;
    .material-icons{
      position: absolute;
      right: 16px; top: 7px;
    }
  }
}

.ps__rail-y .ps__thumb-y{
  background-color: #115457;
}
.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y{
  background-color: #115457;
}

.allContentCnt .allContent .contentItem .contentInfo .category a{
  color: #620509;
}

.modalContent{
  transition: all .2s ease;
}
.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  .modalContent{
    transform: scale(.9);
  }
}

.sectionTitle{
  margin: 0 0 30px;
  font-size: 40px;
  // font-family: 'Source Serif Pro', serif;
  font-weight: 400;
  text-align: center;
  @media (max-width: 1480px) {
    font-size: 32px;
  }
  @media (max-width: 1060px) {
    font-size: 28px;
  }
  @media (max-width: 680px) {
    font-size: 22px;
  }
  &.withSubtitle{
    margin-bottom: 6px;
  }
}
.sectionSubtitle{
  text-align: center;
  font-size: 20px;
  font-weight: 300;
  opacity: .65;
  margin: 0 0 30px;
  @media (max-width: 1480px) {
    font-size: 17px;
  }
  @media (max-width: 680px) {
    font-size: 15px;
    margin-bottom: 16px;
    text-align: center;
  }
}

.field{
  border: #ccc 1px solid;
  border-radius: 5px;
  padding: 10px 14px;
  font-size: 17px;
  background-color: #fff;
  outline: 0;
  box-shadow: none;
  width: 100%;
  box-sizing: border-box;
  line-height: 1.4;
  &:hover{
    border-color: #fff;
    box-shadow: 0 0 0 2px #999;
  }
  &:focus{
    border-color: #fff;
    box-shadow: 0 0 0 2px #369d66;
  }
}

.fieldGroup{
  margin-bottom: 16px;
  label{
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 500;
    margin: 0 0 4px 7px;
    display: block;
    color: #999;
    // font-family: 'Source Serif Pro', serif;
  }
  .fieldCnt{
    position: relative;
    &.hasError{
      .field{
        border-color: #fff;
        box-shadow: 0 0 0 2px red;
      }
      .fieldError{
        display: block;
      }
      .hint{
        display: none;
      }
    }
    &.hasPrefix{
      .field{
        padding-left: 60px;
      }
      .prefix{
        position: absolute;
        left: 1px; top: 1px; bottom: 1px;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px 0 0 5px;
        padding: 0 10px;
        border-right: #e5e5e5 1px solid;
      }
    }
    .showPwd{
      width: 30px; height: 30px;
      position: absolute;
      right: 8px; top: 50%;
      margin-top: -15px;
      border-radius: 50%;
      background-image: url(assets/eye-closed.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      opacity: .8;
      &:hover{
        background-color: #eee;
        opacity: 1;
      }
      &.show{
        background-image: url(assets/eye.png);
      }
    }
  }
  .fieldError{
    color: #ff7979;
    font-size: 12px;
    margin: 6px 0 0 7px;
  }
  .hint{
    color: #767676;
    font-size: 12px;
    margin: 0;
    padding: 6px 0 0 7px;
  }
  &.hasError{
    .field{
      border-color: #fff;
      box-shadow: 0 0 0 2px red;
    }
    .hint{
      display: none;
    }
  }
}

.bcnb{
  margin: 0 20px;
  @media (max-width: 680px){
    margin: 0 16px;
  }
  .breadcrumb{
    font-size: 14px;
    padding: 12px 0;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .bc{
      color: #444;
      margin-right: 10px;
    }
    a.bc{
      color: #002f5f;
    }
    .dv{
      margin-right: 10px;
      color: #ccc;
    }
  }
}
</style>
